import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { LoadingState } from '../../../../types/loading-state';
import { createFetchedData } from '../../../../utils/fetched-data/create-fetched-data';
import { createFetchedDataRecord } from '../../../../utils/fetched-data/create-fetched-data-record';
import { createOrGetFetchedState } from '../../../../utils/fetched-data/create-or-get-fetched-state';
import { generateQueryKey } from '../../../../utils/generate-query-key';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { updateObject } from '../../../../utils/object-utils';
import { browsingDomainStore } from '../../store';
import { assignShowtimeListRelatedData } from '../../utils/showtimes/assign-related-data';
export const loadShowtimesForBusinessDate = async (query, businessDate, reloadCachedData = false) => {
    const queryKey = generateQueryKey(query);
    const showtimeIdsForQuery = createOrGetShowtimeIdsForQueryState(queryKey, businessDate);
    const state = createOrGetFetchedState(showtimeIdsForQuery, businessDate);
    await loadDataFromApi({
        api: () => ocapiClient.instance.v1.browsing.masterData.showtimes.getForBusinessDate(businessDate, query),
        state,
        cacheDuration: getCacheDuration('showtimes'),
        onSuccess,
        reloadCachedData
    });
};
const onSuccess = (response, cacheDuration) => {
    const { showtimes, relatedData } = response;
    const showtimesRecord = createFetchedDataRecord(showtimes, 'id', cacheDuration);
    updateObject(browsingDomainStore.data.showtimesById, showtimesRecord);
    assignShowtimeListRelatedData(relatedData, cacheDuration);
    return showtimes.map(showtime => showtime.id);
};
const createOrGetShowtimeIdsForQueryState = (queryKey, businessDate) => {
    if (!browsingDomainStore.data.showtimeIdsForQueryByBusinessDate[queryKey]) {
        runInAction(() => {
            browsingDomainStore.data.showtimeIdsForQueryByBusinessDate[queryKey] = {
                [businessDate]: createFetchedData(LoadingState.NotLoaded)
            };
        });
    }
    return browsingDomainStore.data.showtimeIdsForQueryByBusinessDate[queryKey];
};
